import { FlowTemplatePreviewPage } from './Page';
import { AgentDetailsProvider } from '../../context';

export function FlowTemplatePreviewPageWithProvider() {
  return (
    <AgentDetailsProvider>
      <FlowTemplatePreviewPage />
    </AgentDetailsProvider>
  );
}
